<template>
  <div>
    <v-flex xs12>
      <OrthopedicProceduresList
        id="proceduresList"
        :value="value"
        :typeOfSurgery="typeOfSurgery"
        :anatomicRegion="anatomicRegion"
        @input="decompressProcedures($event)"
        name="Procedimentos"
        singularName="Procedimento"
      />
    </v-flex>
    <v-flex xs12>
      <HintField
        v-if="hasOtherProcedure"
        componentId="orthopedic-procedure-other"
        label="Procedimento (texto livre)"
        :value="orthopedicProcedureOther"
        @input="$emit('update:orthopedicProcedureOther', $event)"
      />
    </v-flex>
  </div>
</template>
<script>
import HintField from './HintField'
import OrthopedicProceduresList from './OrthopedicProceduresList'

export default {
  components: { OrthopedicProceduresList, HintField },
  props: {
    value: { type: Array, default: () => [] },
    orthopedicProcedureOther: { type: String },
    typeOfSurgery: { type: String },
    anatomicRegion: { type: String }
  },
  data() {
    return {}
  },
  computed: {
    hasOtherProcedure() {
      return this.value.some(d => d.id === 'other')
    }
  },
  methods: {
    decompressProcedures(procedures) {
      document.getElementById('proceduresList').scrollIntoView(false)
      let proceduresIds =
        (procedures && procedures.map(procedure => procedure.id)) || []

      this.$emit('input', procedures)
      this.$emit('update:procedures-ids', proceduresIds)
    }
  }
}
</script>
